import { Button, Flex, FormControl, Grid, Image, Input, Text, useColorMode, useToast, VStack } from '@chakra-ui/react'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'
import { useEffect, useState } from 'react'
import { sanitizeField } from 'functions/sanitizeForm'
import { useSubmitGlucoseValidate } from 'hooks/useGlucoseRegister'
import InputMask from "react-input-mask";

import logoHapvida from "assets/images/logo-hapvida.png"

interface FormField {
    key: string,
    label: string,
    options?: Option[]
}

interface Option {
    label: string
    value: string
}

interface FormData {
    key: string,
    value: string
}

const fields: FormField[] = [
    {
        key: "cpf",
        label: "CPF"
    },
]

const GlucoseValidate = () => {
    const { setColorMode } = useColorMode()

    useEffect(() => {
        setColorMode("light");
    }, [])

    const [cpf, setCpf] = useState<string>("");

    const toast = useToast()
    const [submitForm, { loading: loadingSubmit }] = useSubmitGlucoseValidate({
        onSuccess: (data: any) => {
            const exists = data.glucoseValidate.exists;
            if (exists)
                window.location.replace(`/glicemia-monitoramento?cpf=${sanitizeField(cpf)}`);
            else
                window.location.replace(`/glicemia-registro?cpf=${sanitizeField(cpf)}`);
        },
        onError: () => {
            toast({
                id: "messageSent",
                title: `Ocorreu um erro ao cadastrar`,
                duration: 4000,
                position: "bottom",
                status: "error"
            })
        }
    });

    const onSubmit = () => {
        if(cpf == "" || cpf == null) {
            toast({
                id: "cpfMissing",
                title: `Informe seu CPF.`,
                duration: 3000,
                position: "bottom",
                status: "info"
            })

            return;
        }

        const variables = {
            input: {
                cpf: sanitizeField(cpf)
            }
        }

        submitForm({ variables },);
    }

    return (
        <Flex w="full" minH="100vh" justifyContent="center" alignItems="center">
            <Card maxW="420px" minH="460px">
                <CardHeader minH="80px" justifyContent="center" alignItems="center" mx="auto">
                    <VStack w="full" h="full">
                        <Image src={logoHapvida} maxW="200px" h="auto" />
                        <Text align="center">Monitoramento Glicêmico para Diabetes Gestacional</Text>
                    </VStack>
                </CardHeader>
                <CardBody mt="auto" mb="auto">
                    <Flex flexDirection="column" w="full">
                        <>
                            <Grid
                                w="full"
                                templateColumns="repeat(1, 1fr)"
                                templateRows="repeat(1, 1fr)"
                                gap="16px"
                                mb="8"
                            >
                                <FormControl>
                                    <Text mb={2} fontWeight="bold" fontSize="md">Informe seu CPF</Text>
                                    <Input
                                        value={cpf}
                                        onChange={({ target }) => setCpf(target.value)}
                                        as={InputMask}
                                        mask={"999.999.999-99"}
                                        borderRadius="8px"
                                        fontSize="md"
                                    />
                                </FormControl>
                            </Grid>
                            <Flex w="full" mb="2">
                                <Button
                                    isLoading={loadingSubmit}
                                    disabled={loadingSubmit}
                                    w="full"
                                    colorScheme="blue"
                                    onClick={onSubmit}
                                >Entrar</Button>
                            </Flex>
                        </>
                    </Flex>
                </CardBody>
            </Card>
        </Flex>
    )
}

export default GlucoseValidate